import { render } from "./ModalNewOrdine.vue?vue&type=template&id=48fc9d0f&scoped=true"
import script from "./ModalNewOrdine.vue?vue&type=script&lang=js"
export * from "./ModalNewOrdine.vue?vue&type=script&lang=js"

import "./ModalNewOrdine.vue?vue&type=style&index=0&id=48fc9d0f&scoped=true&lang=css"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48fc9d0f"]])

export default __exports__